import { render, staticRenderFns } from "./FabricFactoryManagement.vue?vue&type=template&id=5f166a4c&scoped=true"
import script from "./FabricFactoryManagement.vue?vue&type=script&lang=js"
export * from "./FabricFactoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f166a4c",
  null
  
)

export default component.exports